import React from "react";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer
      data-testid="site-footer"
      className="bg-black border-t border-white/10 py-16 md:py-20"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <div className="flex items-center gap-3">
              <span className="h-2.5 w-2.5 bg-red-500 pulse-dot" />
              <span className="font-mono text-xs uppercase tracking-[0.28em] text-white">
                High-Risk<span className="text-red-500">/</span>Algorithms
              </span>
            </div>
            <p className="mt-6 font-body text-sm text-gray-400 leading-relaxed max-w-md">
              The dominant brand for exposing predatory algorithms and arming businesses with
              the counter-strategy. We help people, founders, and operators see what they have
              been priced into.
            </p>
            <p className="mt-6 font-mono text-[11px] uppercase tracking-[0.24em] text-gray-500">
              highriskalgorithms.com
            </p>
          </div>

          <div className="md:col-span-3">
            <div className="font-mono text-[11px] uppercase tracking-[0.28em] text-red-400 mb-5">
              Navigate
            </div>
            <ul className="space-y-3 font-body text-sm text-gray-300">
              <li><a href="#manifesto" className="link-underline">Manifesto</a></li>
              <li><a href="#services" className="link-underline">Services</a></li>
              <li><a href="#exposed" className="link-underline">Exposed Files</a></li>
              <li><a href="#contact" className="link-underline">Contact</a></li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <div className="font-mono text-[11px] uppercase tracking-[0.28em] text-red-400 mb-5">
              Trademark & IP Notice
            </div>
            <p className="font-body text-xs text-gray-400 leading-relaxed">
              HIGH-RISK ALGORITHMS™, HIGH-RISK ALGORITHM™, and the related brand marks, methods,
              service taxonomy, and audit frameworks are claimed brand assets. Domains{" "}
              <span className="text-gray-200">highriskalgorithms.com</span> and{" "}
              <span className="text-gray-200">highriskalgorithm.com</span> are both claimed
              brand assets. Imitation, duplication, derivative branding, infringement, or
              passing-off — by any party, in any jurisdiction, at any time, now or forever —
              is expressly prohibited and will be pursued. All rights reserved.
            </p>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/10 flex flex-col md:flex-row md:items-center md:justify-between gap-4">
          <div className="font-mono text-[10px] uppercase tracking-[0.28em] text-gray-500">
            © {year} High-Risk Algorithms™ · Founded by Romona Nicole Schmidt. All rights reserved.
          </div>
          <div className="font-mono text-[10px] uppercase tracking-[0.28em] text-gray-500">
            Built to expose the thrones of iniquity — Psalms 90:24.
          </div>
        </div>
      </div>
    </footer>
  );
}
